module.exports = __webpack_public_path__ + "static/media/ServerCluster.3486cfba.svg";